import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { IxellAPIService, IActivationV1, Roles, IIColorUserV1, IColorUserV1, ICtcV1 } from '../../tools/api.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/app/tools/storage.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Utils } from 'src/app/tools/utils';

import { Scale } from 'src/app/models/scale.model';
import { User } from 'src/app/models/user.model';
import { Company } from 'src/app/models/company.model';
import { Billing } from 'src/app/models/billing.model';
import { HeaderService } from 'src/app/tools/header.service';
import { ErrorService } from 'src/app/tools/error.service';
import { Constants, Country } from 'src/app/entities/Constants';
import { Sort } from '@angular/material/sort';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { TmplAstContent } from '@angular/compiler';

@Component({
    selector: 'laca_userclientform',
    templateUrl: './user-client-formV2.component.html',
    styleUrls: ['./user-client-formV2.component.scss'],
})

export class UserClientFormComponentV2 implements OnInit, OnDestroy {
    @ViewChild('stepper') stepper: MatStepper;

    isAdminLacour: boolean;
    isPreprod: boolean;
    infoPreprod: boolean = false;

    public token: string;
    checked = false;
    checkedClient = false;
    actif: boolean = false;
    countries: any[];
    languages: any[] = [];

    numSerieForm = new UntypedFormGroup({
        code: new UntypedFormControl('', [Validators.required, Validators.maxLength(4)])
    });
    verifyCode = this.numSerieForm.value.code;

    companyForm = new UntypedFormGroup({
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        siret: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    })

    payorSocietyForm = new UntypedFormGroup({
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        siret: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    })

    userForm = new UntypedFormGroup({
        mail: new UntypedFormControl('', [Validators.email, Validators.required]),
        gender: new UntypedFormControl('', [Validators.required]),
        name: new UntypedFormControl('', [Validators.required]),
        firstname: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        mobile: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required])
    })

    payorForm = new UntypedFormGroup({
        mail: new UntypedFormControl('', [Validators.email, Validators.required]),
        gender: new UntypedFormControl('', [Validators.required]),
        name: new UntypedFormControl('', [Validators.required]),
        firstname: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        mobile: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required])
    })

    searchCustomerForm = new UntypedFormGroup({
        country: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required])
    });

    editCustomerForm = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ])),
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),
        businessCode: new UntypedFormControl(''),

        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl('')
    });

    otherCustomerForm = new UntypedFormGroup({
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        language: new UntypedFormControl('', [Validators.required]),
        businessCode: new UntypedFormControl('', [Validators.required]),

        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required])
    });

    addCustomerEmailForm = new UntypedFormGroup({
        email: new UntypedFormControl('', Validators.compose([
            Validators.required,
            Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}')
        ]))
    });

    addCustomerCompanyForm = new UntypedFormGroup({
        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        country: new UntypedFormControl('', [Validators.required]),
        siret: new UntypedFormControl(''),
        tva: new UntypedFormControl('')
    });

    similarCompanyForm = new UntypedFormGroup({
        similarCompany: new UntypedFormControl('', [Validators.required])
    });

    dataCompanyForm = new UntypedFormGroup({
        dataCompany: new UntypedFormControl('', [Validators.required])
    });

    customerCompanyForm = new UntypedFormGroup({
        customerCompany: new UntypedFormControl('', [Validators.required])
    });

    addCustomerForm = new UntypedFormGroup({
        name: new UntypedFormControl('', [Validators.required]),
        firstName: new UntypedFormControl('', [Validators.required]),
        mobile: new UntypedFormControl('', [Validators.required]),
        phone: new UntypedFormControl(''),
        language: new UntypedFormControl('', [Validators.required]),
        businessCode: new UntypedFormControl(''),

        ctc: new UntypedFormControl(''),
        idCtc: new UntypedFormControl('', [Validators.required]),

        customerNumber: new UntypedFormControl('', [Validators.required]),
        customerCode: new UntypedFormControl('', [Validators.required]),
        compteTresor: new UntypedFormControl('', [Validators.required]),
        haveScale: new UntypedFormControl(''),
        paintBrand: new UntypedFormControl('')
    });


    listOfBrands = [
        "Ixell",
        "Autocolor",
        "Cromax",
        "DeBeer",
        "Glasurit",
        "Lechler",
        "Lesonal",
        "Max Meyer",
        "PPG",
        "RM",
        "Sikkens",
        "Spie Hecker",
        "Standox",
        "Autre"
    ]

    activToken: any;

    private userDataSub: any;
    private userFkDataSub: any;
    private customerDataSub: any;
    private verifySub: any;
    private roleSub: any;
    private payorMailSub: any;
    private userMailSub: any;
    private searchCustomersSub: any;
    private saveAndSendIDSub: any;
    private dataSub: any;
    private regionsSub: any;
    private saveSub: any;
    private checkMailSub: any;
    private getSimilarCompanySub: any;
    private getCustomersCompanySub: any;
    private updateColorUserSub: any;
    private ctcSub: any;
    private insertScaleHistorySub: any;

    errorUserMsg = false;
    errorPayorMsg = false;
    errorScaleMsg = false;

    billingObj: Billing;
    loginCtc: any;
    scale: Scale;
    user: User;
    userCompany: Company;
    payor: User;
    payorCompany: Company;
    payorSocietyCountry: string;
    sameAsUser: boolean = false;
    sameFacturationAsUser: boolean = false;
    isSearchCustomer: boolean = false;
    isFinish: boolean = false;
    mprRenault: boolean = false;
    mprRenaultOther: boolean = false;
    emailExists: boolean = false;
    showOther: boolean = false;
    isUser: boolean = false;
    isRedirectAffectation: boolean = false;
    isPayor: boolean = false;
    userSelected: IColorUserV1;
    payorSelected: IColorUserV1;
    customersLst: IColorUserV1[] = [];
    customersSource: any;
    currentCustomer: IColorUserV1;
    isModifCustomer: boolean = false;
    otherCustomer: IColorUserV1;
    regions: string[] = [];
    Utils = Utils;
    role: Roles = Roles.Unknown;
    newCustomer: boolean = false;
    haveScale: boolean = false;
    ctcsFiltered: ICtcV1[] = [];

    companyEntered: IColorUserV1;
    companySelected: any;
    dataCompanySelected: any;
    similarCustomers: IColorUserV1[];
    similarCompany: any[];
    isNewCompany: boolean = false;
    customerCompanySelected: any;
    errorMsgMail: boolean = false;
    errorMsgCompany: boolean = false;
    errorMsgVerifCompany: boolean = false;
    errorMsgCustomer: boolean = false;
    msgConfirmation: boolean = false;
    addCustomer: boolean = false;
    showMailForm: boolean = false;
    showCompanyForm: boolean = false;
    showListCompany: boolean = false;
    showVerifCompany: boolean = false;
    showCustomerCompany: boolean = false;
    showCustomerForm: boolean = false;
    showEditForm: boolean = false;
    showOtherEdit: boolean = false;
    checkedAnnuaire: boolean = false;
    tvaCkeck: boolean = false;

    displayedColumns = ["companySocialReason", "address", "firstName", "name", "mail", "sended", "action"];

    constructor(private storageService: StorageService, public dialog: MatDialog, private apiService: IxellAPIService, private formBuilder: UntypedFormBuilder,
        private router: Router, private storage: StorageService, private route: ActivatedRoute,
        private headerService: HeaderService, private errorService: ErrorService) { }

    ngAfterViewInit() {
        this.stepper._getIndicatorType = () => 'number';
        //// Suppression des messages d'erreur en cas de modif du formulaire
        // Utilisateur
        this.userForm.valueChanges.subscribe(data => {
            if (this.errorUserMsg == true) this.errorUserMsg = false;
        });
        this.companyForm.valueChanges.subscribe(data => {
            if (this.errorUserMsg == true) this.errorUserMsg = false;
        });
        // Payeur 
        this.payorForm.valueChanges.subscribe(data => {
            if (this.errorPayorMsg == true) this.errorPayorMsg = false;
        });
        this.payorSocietyForm.valueChanges.subscribe(data => {
            if (this.errorPayorMsg == true) this.errorPayorMsg = false;
        });
        // Ajout nouvel utilisateur
        this.addCustomerForm.valueChanges.subscribe(data => {
            if (this.msgConfirmation == true) this.msgConfirmation = false;
        });
        // Verif infos utilisateur
        this.editCustomerForm.valueChanges.subscribe(data => {
            if (this.msgConfirmation == true) this.msgConfirmation = false;
        });
    }

    ngOnInit() {

        this.isPreprod = Utils.IsPreprod();
        //document.getElementById("infoPreprodModal").style.display = "block";

        this.countries = Utils.countries();
        this.languages = Utils.languages();
        this.storageService.redirect();
        let code = this.route.snapshot.paramMap.get('code');
        if (!Utils.IsNullOrWhiteSpace(code)) {
            this.numSerieForm.setValue({
                code: code
            });
        }
        let scaleCode: string = sessionStorage.getItem("activationCode");
        if (scaleCode) {
            sessionStorage.removeItem("activationCode");
            this.headerService.verifyRole();
        }
        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role;
            this.isAdminLacour = Utils.isAdminLacour(role);
        });
        this.headerService.changeTitle("support.supportAssistance");
        this.headerService.changeCanBack(true);


        let idClient = parseInt(this.route.snapshot.paramMap.get('idClient'));
        // console.log(idClient);
        if (idClient && idClient != 0) {
            this.userDataSub = this.apiService.selectClientsById(idClient).subscribe(data => {
                if (data) {
                    this.isRedirectAffectation = true;
                    this.selectCustomer(data);
                }
            }, error => {
                if (this.userDataSub != null) this.userDataSub.unsubscribe();
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "verifyBalance", new Date().toString());
            });
        }
        

    }

    ngOnDestroy() {
        if (this.userDataSub != null) this.userDataSub.unsubscribe();
        if (this.userFkDataSub != null) this.userFkDataSub.unsubscribe();
        if (this.customerDataSub != null) this.customerDataSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.verifySub != null) this.verifySub.unsubscribe();
        if (this.dataSub != null) this.dataSub.unsubscribe();
        if (this.payorMailSub != null) this.payorMailSub.unsubscribe();
        if (this.userMailSub != null) this.userMailSub.unsubscribe();
        if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
        if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
        if (this.regionsSub != null) this.regionsSub.unsubscribe();
        if (this.saveSub != null) this.saveSub.unsubscribe();
        if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
        if (this.updateColorUserSub != null) this.updateColorUserSub.unsubscribe();
        if (this.ctcSub != null) this.ctcSub.unsubscribe();
    }

    verifyScale() {
        if (this.numSerieForm.status == "VALID") {
            this.verifySub = this.apiService.verifyBalance(this.numSerieForm.value.code).subscribe(data => {
                if (data == true) {
                    document.getElementById("scaleStepper").click();
                    this.errorScaleMsg = false;
                } else {
                    this.errorScaleMsg = true;
                }
            }, error => {
                if (this.verifySub != null) this.verifySub.unsubscribe();
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "verifyBalance", new Date().toString());
            })
        }
    }

    getUser() {
        this.isUser = true;
        this.isPayor = false;
        this.isSearchCustomer = true;
        let modal = document.getElementById("finalModal");
        modal.style.display = "flex";
        let country: string = this.storage.get("country");
        if (country) {
            this.searchCustomerForm.setValue({
                country: this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name,
                postalCode: ""
            });
        }
    }

    getPayor() {
        this.isUser = false;
        this.isPayor = true;

        this.isSearchCustomer = true;
        let modal = document.getElementById("finalModal");
        modal.style.display = "flex";
        let country: string = this.storage.get("country")
        if (country) {
            this.searchCustomerForm.setValue({
                country: this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name,
                postalCode: ""
            });
        }
    }

    getRegions(other: boolean, type: string, initCtc: boolean) {
        var companyCountry = this.addCustomerCompanyForm.value.country;

        if (companyCountry && (companyCountry.toLowerCase() == "france" || companyCountry.toLowerCase() == "spain" || companyCountry.toLowerCase() == "united kingdom")) {
            this.regionsSub = this.apiService.getRegions(companyCountry).subscribe(data => {
                if (data) {
                    this.regions = data;
                }
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            });
            this.mprRenault = true;
            this.addCustomerForm.controls['businessCode'].setValidators([Validators.required]);
            this.addCustomerForm.controls['businessCode'].markAsTouched();
        }
        else {
            this.mprRenault = false;
            this.addCustomerForm.controls['businessCode'].setValidators([]);
            this.addCustomerForm.controls['businessCode'].markAsTouched();
        }

        if (this.otherCustomerForm.value.country && (this.otherCustomerForm.value.country.toLowerCase() == "france" || this.otherCustomerForm.value.country.toLowerCase() == "spain" || this.otherCustomerForm.value.country.toLowerCase() == "united Kingdom")) {
            this.regionsSub = this.apiService.getRegions(this.otherCustomerForm.value.country).subscribe(data => {
                if (data) {
                    this.regions = data;
                }
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            });
            this.mprRenaultOther = true;
            this.otherCustomerForm.controls['businessCode'].setValidators([Validators.required]);
            this.otherCustomerForm.controls['businessCode'].markAsTouched();
        }
        else {
            this.mprRenaultOther = false;
            this.otherCustomerForm.controls['businessCode'].setValidators([]);
            this.otherCustomerForm.controls['businessCode'].markAsTouched();
        }

        if (this.editCustomerForm.value.country && (this.editCustomerForm.value.country.toLowerCase() == "france" || this.editCustomerForm.value.country.toLowerCase() == "spain" || this.editCustomerForm.value.country.toLowerCase() == "united kingdom")) {
            this.regionsSub = this.apiService.getRegions(this.editCustomerForm.value.country).subscribe(data => {
                if (data) {
                    this.regions = data;
                }
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            });
            this.mprRenault = true;
            this.editCustomerForm.controls['businessCode'].setValidators([Validators.required]);
            this.editCustomerForm.controls['businessCode'].markAsTouched();
        }
        else {
            this.mprRenault = false;
            this.editCustomerForm.controls['businessCode'].setValidators([]);
            this.editCustomerForm.controls['businessCode'].markAsTouched();
        }

        this.otherCustomerForm.controls['businessCode'].updateValueAndValidity();
        this.addCustomerForm.controls['businessCode'].updateValueAndValidity();
        this.editCustomerForm.controls['businessCode'].updateValueAndValidity();

        if (initCtc) {
            this.loadCtcOfDrCustomer(type, "region");
        }

        /*this.changeAddCustomerCompanyFormCountryFacturation();*/

    }

    verifyUserForm() {
        if (this.userForm.status == 'VALID' && this.companyForm.status) {
            document.getElementById("userStepper").click();
            this.errorUserMsg = false;
            if (this.sameAsUser) {
                this.checkedClient = false;
                this.copyClientData();
                this.checkedClient = true;
            }
            if (this.sameFacturationAsUser) {
                this.checked = false;
                this.copyFacturationData();
                this.checked = true;
            }
        }
        else {
            this.userForm.markAllAsTouched();
            this.companyForm.markAllAsTouched();
            this.errorUserMsg = true;
            if (Utils.IsNullOrWhiteSpace(this.userForm.value.gender)) {
                document.getElementById("userH").style.color = "#f44336";
                document.getElementById("userF").style.color = "#f44336";
            }
        }
    }

    // FAIRE LES COPies
    copyFacturationData() {
        if (!this.checked) {
            this.payorSocietyForm.reset();
            this.sameFacturationAsUser = false;
        }
        else {

            console.log(this.companyForm);

            this.payorSocietyForm.setValue({
                socialReason: this.companyForm.value.socialReason,
                address: this.companyForm.value.address,
                postalCode: this.companyForm.value.postalCode,
                city: this.companyForm.value.city,
                country: this.companyForm.value.country,
                siret: this.companyForm.value.siret,
                tva: this.companyForm.value.tva
            });
            this.sameFacturationAsUser = true;
        }
    }

    copyClientData() {
        if (!this.checkedClient) {
            this.payorForm.reset();
            this.sameAsUser = false;
        }
        else {
            this.payorForm.setValue({
                gender: this.userForm.value.gender,
                name: this.userForm.value.name,
                firstname: this.userForm.value.firstname,
                mail: this.userForm.value.mail,
                phone: this.userForm.value.phone,
                mobile: this.userForm.value.mobile,
                language: this.userForm.value.language
            });
            this.sameAsUser = true;
            this.payorSelected = this.userSelected;
        }
    }

    sendAllData() {
        if (this.userForm.status == "VALID" && this.companyForm.status == "VALID" && this.payorSocietyForm.status == "VALID" && this.payorForm.status == "VALID"
            && this.numSerieForm.status == "VALID") {
            this.activationData(this.numSerieForm.value, this.companyForm.value, this.userForm.value, this.payorSocietyForm.value, this.payorForm.value);

            this.sendEverything();
            // MAJ des infos de l'utilisateur ou du payeur dans la table colorUser
            this.updateInfosColorUser();
            this.errorPayorMsg = false;
        } else {
            // Pour trigger les mat-error
            this.userForm.markAllAsTouched();
            this.companyForm.markAllAsTouched();
            this.payorSocietyForm.markAllAsTouched();
            this.payorForm.markAllAsTouched();
            this.numSerieForm.markAllAsTouched();
            this.errorPayorMsg = true;
            if (Utils.IsNullOrWhiteSpace(this.payorForm.value.gender)) {
                document.getElementById("payorH").style.color = "#f44336";
                document.getElementById("payorF").style.color = "#f44336";
            }
        }
    }

    updateInfosColorUser() {

        let userNew: IColorUserV1 = new IColorUserV1();
        userNew.name = this.userForm.value.name.trim();
        userNew.firstname = this.userForm.value.firstname.trim();
        userNew.mobilePhone = this.userForm.value.mobile.trim();
        userNew.phone = this.userForm.value.phone == null ? null : this.userForm.value.phone.trim();
        userNew.language = this.userForm.value.language.trim();
        userNew.socialReason = this.companyForm.value.socialReason.trim();
        userNew.address = this.companyForm.value.address.trim();
        userNew.postalCode = this.companyForm.value.postalCode.trim();
        userNew.city = this.companyForm.value.city.trim();
        userNew.country = this.companyForm.value.country.trim();

        let userOld: IColorUserV1 = new IColorUserV1();
        userOld.name = this.userSelected.name.trim();
        userOld.firstname = this.userSelected.firstname.trim();
        userOld.mobilePhone = this.userSelected.mobilePhone.trim();
        userOld.phone = this.userSelected.phone == null ? null : this.userSelected.phone.trim();
        userOld.language = this.userSelected.language.trim();
        userOld.socialReason = this.userSelected.socialReason.trim();
        userOld.address = this.userSelected.address.trim();
        userOld.postalCode = this.userSelected.postalCode.trim();
        userOld.city = this.userSelected.city.trim();
        userOld.country = this.userSelected.country.trim();

        let payorNew: IColorUserV1 = new IColorUserV1();
        payorNew.name = this.payorForm.value.name.trim();
        payorNew.firstname = this.payorForm.value.firstname.trim();
        payorNew.mobilePhone = this.payorForm.value.mobile.trim();
        payorNew.phone = this.payorForm.value.phone == null ? null : this.payorForm.value.phone.trim();
        payorNew.language = this.payorForm.value.language.trim();
        payorNew.socialReason = this.payorSocietyForm.value.socialReason.trim();
        payorNew.address = this.payorSocietyForm.value.address.trim();
        payorNew.postalCode = this.payorSocietyForm.value.postalCode.trim();
        payorNew.city = this.payorSocietyForm.value.city.trim();
        payorNew.country = this.payorSocietyForm.value.country.trim();

        let payorOld: IColorUserV1 = new IColorUserV1();
        payorOld.name = this.payorSelected.name.trim();
        payorOld.firstname = this.payorSelected.firstname.trim();
        payorOld.mobilePhone = this.payorSelected.mobilePhone.trim();
        payorOld.phone = this.payorSelected.phone == null ? null : this.payorSelected.phone.trim();
        payorOld.language = this.payorSelected.language.trim();
        payorOld.socialReason = this.payorSelected.socialReason.trim();
        payorOld.address = this.payorSelected.address.trim();
        payorOld.postalCode = this.payorSelected.postalCode.trim();
        payorOld.city = this.payorSelected.city.trim();
        payorOld.country = this.payorSelected.country.trim();

        if (this.sameAsUser) {
            if (!(JSON.stringify(userNew) === JSON.stringify(userOld))) { // si infos Utilisateur différentes -> update Utilisateur
                this.updateColorUser(userNew, this.userSelected.idcolorUser);
            }
        }
        else {
            if (!(JSON.stringify(userNew) === JSON.stringify(userOld))) { // si infos Utilisateur différentes -> update Utilisateur
                this.updateColorUser(userNew, this.userSelected.idcolorUser);
            }
            if (!(JSON.stringify(payorNew) === JSON.stringify(payorOld))) { // si infos Payeur différentes -> update Payeur
                this.updateColorUser(payorNew, this.payorSelected.idcolorUser);
            }
        }
    }

    updateColorUser(user, id) {

        this.updateColorUserSub = this.apiService.updateColorUser(user, id).subscribe(data => {
            if (data) {
            } else {
                if (this.updateColorUserSub != null) this.updateColorUserSub.unsubscribe();
            }
        }, error => {
            if (this.updateColorUserSub != null) this.updateColorUserSub.unsubscribe();
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "updateColorUser", new Date().toString());
            console.log(error);
        });
    }

    removeGenderError(customer: string) {

        let genderH = (customer == "user") ? "userH" : "payorH";
        let genderF = (customer == "user") ? "userF" : "payorF";

        if (document.getElementById(genderH).style.color = "#f44336")
            document.getElementById(genderH).style.color = "black";

        if (document.getElementById(genderF).style.color = "#f44336")
            document.getElementById(genderF).style.color = "black";
    }

    changeAddCustomerCompanyFormCountryFacturation() {
        if (this.addCustomerCompanyForm.value["country"] != "" && this.addCustomerCompanyForm.value["country"] != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.addCustomerCompanyForm.value["country"].toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.addCustomerCompanyForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.addCustomerCompanyForm.value["country"].toLowerCase()).tvaRegEx)]);
                this.addCustomerCompanyForm.controls['tva'].updateValueAndValidity();
                //this.tvaCkeck = true;
            } else {
                this.addCustomerCompanyForm.controls['tva'].clearValidators();
                this.addCustomerCompanyForm.controls['tva'].updateValueAndValidity();
                if (this.addCustomerCompanyForm.value.tva != "") {
                    this.addCustomerCompanyForm.controls["tva"].setValue("");
                }
                //this.tvaCkeck = false;
            }
        }
    } 

    changeCountryFacturation() {


        if (this.payorSocietyCountry != "" && this.payorSocietyCountry != undefined) {
            var tvaRegEx = Constants.countries.find(c => c.name.toLowerCase() == this.payorSocietyCountry.toLowerCase()).tvaRegEx;
            if (tvaRegEx != "") {
                this.payorSocietyForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.payorSocietyCountry.toLowerCase()).tvaRegEx)]);
                this.payorSocietyForm.controls['tva'].updateValueAndValidity();
                this.tvaCkeck = true;
            } else {
                this.payorSocietyForm.controls['tva'].clearValidators();
                this.payorSocietyForm.controls['tva'].updateValueAndValidity();
                //this.payorSocietyForm.controls['tva'].markAsTouched();
                if (this.payorSocietyForm.value.tva != "") {
                    //this.payorSocietyForm.get('tva').patchValue("", { emitEvent: false });
                    this.payorSocietyForm.controls["tva"].setValue("");
                }
                this.tvaCkeck = false;
            }

            //this.payorSocietyForm.controls["tva"].setValidators([Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.payorSocietyCountry.toLowerCase()).tvaRegEx)]);
            //this.payorSocietyForm.controls["tva"].updateValueAndValidity();
        }
    }

    changeCountry() {
        this.changeCountryFacturation();
    }


    //checkTvaIntra() {
    //  //this.changeCountryFacturation()
    //  let countryFact: string = this.companyForm.value["country"];
    //  if (countryFact && countryFact.toLowerCase() == "france") {
    //    this.isFrench = true;
    //    this.tauxTva = 20;
    //  }
    //  else {
    //    this.isFrench = false;
    //    this.tauxTva = 0;
    //  }
    //}

    activationData(scaleNum: Scale, userSociety: Company, user: User, payorSociety: Company, payor: User) {

        this.scale = scaleNum;
        this.userCompany = userSociety;
        this.user = user;
        this.payorCompany = payorSociety;
        this.payor = payor;
    }

    sendEverything() {

        if (!this.actif) {
            this.actif = true;
            let activation = new IActivationV1();
            activation.scale = Scale.parseToScale(this.scale);
            activation.user = User.parseToUser(this.user);
            activation.userCompany = Company.parseToCompany(this.userCompany);
            activation.payor = User.parseToUser(this.payor);
            activation.payorCompany = Company.parseToCompany(this.payorCompany);
            this.loginCtc = this.storageService.get("UserID");

            if (JSON.stringify(activation.user) === JSON.stringify(activation.payor)) {
                activation.userCompany.siret = activation.payorCompany.siret;
                activation.userCompany.tva = activation.payorCompany.tva;
                // Null pour l'API
                activation.payorCompany = null;
                activation.payor = null;
                //console.log(activation);
                this.dataSub = this.apiService.setBalanceActivation(activation).subscribe(data => {
                    if (data) {
                        this.isFinish = true;
                        // Vider les objets
                        this.scale = null;
                        this.user = null;
                        this.userCompany = null;
                        this.payor = null;
                        this.payorCompany = null;
                        let modal = document.getElementById("finalModal");
                        modal.style.display = "flex";
                        this.actif = false;
                    } else {
                        if (this.dataSub != null) this.dataSub.unsubscribe();
                    }
                }, error => {
                    this.actif = false;
                    if (this.dataSub != null) this.dataSub.unsubscribe();
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "setBalanceActivation", new Date().toString());
                    console.log(error);
                });

            }
            else {
                this.dataSub = this.apiService.setBalanceActivation(activation).subscribe(data => {
                    if (data) {
                        this.isFinish = true;
                        // Vider les objets
                        this.scale = null;
                        this.user = null;
                        this.userCompany = null;
                        this.payor = null;
                        this.payorCompany = null;
                        let modal = document.getElementById("finalModal");
                        modal.style.display = "flex";
                        this.actif = false;
                    } else {
                        if (this.dataSub != null) this.dataSub.unsubscribe();
                    }
                }, error => {
                    this.actif = false;
                    if (this.dataSub != null) this.dataSub.unsubscribe();
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "setBalanceActivation", new Date().toString());
                    console.log(error);
                })
            }
        }
    }

    openColorUserInfo(customer: IColorUserV1, isNew: boolean) {

        this.showMailForm = true;
        this.errorMsgMail = false;
        this.newCustomer = isNew;
        this.currentCustomer = (this.newCustomer) ? new IColorUserV1 : customer;
        this.isModifCustomer = (this.newCustomer) ? false : true;

        if (this.currentCustomer.country && (this.currentCustomer.country.toLowerCase() == "france" || this.currentCustomer.country.toLowerCase() == "spain" || this.currentCustomer.country.toLowerCase() == "united kingdom")) {
            this.mprRenault = true;
            this.regionsSub = this.apiService.getRegions(this.currentCustomer.country).subscribe(data => {
                if (data) {
                    this.regions = data;
                }
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.regionsSub != null) this.regionsSub.unsubscribe();
            });
        }
        else
            this.mprRenault = false;

        if (this.isModifCustomer) {
            this.showEditForm = true;
            let tmpCountry: any = this.countries.find(c => c.name.toLowerCase() == this.currentCustomer.country.toLowerCase() || c.vo.toLowerCase() == this.currentCustomer.country.toLowerCase());
            if (tmpCountry)
                tmpCountry = tmpCountry.name;
            else
                tmpCountry = this.currentCustomer.country;

            this.editCustomerForm.setValue({
                email: this.currentCustomer.mail,
                socialReason: this.currentCustomer.socialReason,
                address: this.currentCustomer.address,
                postalCode: this.currentCustomer.postalCode,
                city: this.currentCustomer.city,
                country: tmpCountry,
                name: this.currentCustomer.name,
                firstName: this.currentCustomer.firstname,
                phone: this.currentCustomer.phone,
                mobile: this.currentCustomer.mobilePhone,
                language: this.currentCustomer.language,
                businessCode: this.currentCustomer.businessCode,

                ctc: this.currentCustomer.ctcName,
                idCtc: this.currentCustomer.idCtc,

                customerNumber: this.currentCustomer.mrpAccount,
                customerCode: this.currentCustomer.customerCode,
                compteTresor: this.currentCustomer.compteTresor,
                haveScale: this.currentCustomer.haveScale,
                paintBrand: this.currentCustomer.paintBrand
            });

            this.ctcSub = this.apiService.getLstCtcByCountryAndOrDR(this.currentCustomer.country, this.currentCustomer.businessCode).subscribe(data => {
                this.ctcsFiltered = data;
                if (this.ctcSub != null) this.ctcSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.ctcSub != null) this.ctcSub.unsubscribe();
            });
        }
        else {
            this.showEditForm = false;
            let country: string = this.storage.get("country");
            this.addCustomerCompanyForm.controls["country"].setValue(this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name);
        }
    }

    initLanguage() {

        let language = this.storage.get("actualLanguage");
        this.addCustomerForm.controls["language"].setValue(this.languages.find(c => c.code.toLowerCase() == language.toLowerCase()).name);
    }

    checkMail(mail: string, type: string) {

        this.emailExists = false;
        this.hideOtherCustomer(type);
        this.otherCustomer = new IColorUserV1();
        this.checkMailSub = this.apiService.checkMail(mail, this.currentCustomer.idcolorUser).subscribe(data => {
            if (data) {
                this.emailExists = true;
                this.otherCustomer = data;
                if (type == 'edit') this.showEditForm = false;
            }
            else {
                if (type == 'edit') this.showEditForm = true;
            }
        }, error => {
            console.log(error);
            if (this.checkMailSub != null) this.checkMailSub.unsubscribe();
        });
        this.errorMsgMail = this.addCustomerEmailForm.valid ? false : true;
    }

    /////// Rechercher un utilisateur
    searchCustomer() {

        this.resetAddCustomerPart();
        this.currentCustomer = null;
        this.isModifCustomer = false;
        this.editCustomerForm.reset();
        this.emailExists = false;
        this.showOther = false;
        this.otherCustomer = new IColorUserV1();
        this.otherCustomerForm.reset();
        if (this.searchCustomerForm.valid) {
            let postalCode = this.searchCustomerForm.value.postalCode;
            var pays = this.searchCustomerForm.controls['country'].value;
            let country = pays;
            var annuaireIxell = this.checkedAnnuaire;

            //switch (pays) {
            //  case "Germany": country = "Deutschland"; break;
            //  case "United Kingdom": country = "United Kingdom"; break;
            //  //case "Spain": country = "España"; break;
            //  case "Spain": country = "Spain"; break;
            //  case "France": country = "France"; break;
            //  case "Belgium": country = "Belgique"; break;
            //  case "Italy": country = "Italia"; break;
            //  case "luxembourg": country = "luxembourg"; break;
            //  case "Netherlands": country = "Netherlands"; break;
            //  case "Romania": country = "Romania"; break;
            //  case "Poland": country = "Polska"; break;
            //  case "Portugal": country = "Portugal"; break;
            //  case "Turkey": country = "TÜRKİYE"; break;
            //}

            this.searchCustomersSub = this.apiService.getClientsByCountryAndPostalCode(country, postalCode, false, true, annuaireIxell).subscribe(data => {
                if (data) {
                    this.customersSource = null;
                    this.customersLst = data.sort((a, b) => { return compare(a.idcolorUser, b.idcolorUser, false); })
                    if (this.customersLst.length > 0) {
                        this.customersSource = new MatTableDataSource(this.customersLst.slice());
                    }
                }
                if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.searchCustomersSub != null) this.searchCustomersSub.unsubscribe();
            });
        }
    }
    ///////

    /////// Ajout d'un nouvel utilisateur
    showAddCustomer() {

        this.addCustomer = true;
        if (this.emailExists) {
            this.emailExists = false;
            this.currentCustomer = new IColorUserV1;
            this.otherCustomer = new IColorUserV1;
            this.showOther = false;
            this.showOtherEdit = false;
        }
        this.openColorUserInfo(new IColorUserV1(), true);
        this.getRegions(true, "new", true);
        this.changeAddCustomerCompanyFormCountryFacturation();
    }

    closeAddCustomer() {

        this.resetAddCustomerPart();
        if (this.emailExists) {
            this.emailExists = false;
            this.otherCustomer = new IColorUserV1;
            this.showOther = false;
        }
    }

    resetAddCustomerPart() {

        this.addCustomer = false;
        this.addCustomerEmailForm.reset();
        this.addCustomerCompanyForm.reset();
        this.addCustomerForm.reset();
        //this.similarCustomerForm.reset();
        this.similarCompanyForm.reset();
        this.dataCompanyForm.reset();
        this.customerCompanyForm.reset();

        this.showMailForm = false;
        this.showCompanyForm = false;
        this.showListCompany = false;
        this.showVerifCompany = false;
        this.showCustomerCompany = false;
        this.showCustomerForm = false;
        this.currentCustomer = null;
        this.haveScale = false;
        this.companySelected = null;
        this.customerCompanySelected = null;
    }

    validMailForm() {

        setTimeout(() => {
            if (this.emailExists == false) {
                if (this.addCustomerEmailForm.valid) {
                    this.showCompanyForm = true;
                    this.showMailForm = false;
                }
                else {
                    this.addCustomerEmailForm.markAllAsTouched();
                }
            }
        }, 500);
    }

    /// Vue Formulaire Société
    searchSimilarCompany() {

        if (this.addCustomerCompanyForm.status == "VALID" && this.addCustomerEmailForm.status == "VALID") {
            this.companyEntered = new IColorUserV1;
            this.companyEntered.socialReason = this.addCustomerCompanyForm.controls['socialReason'].value;
            this.companyEntered.address = this.addCustomerCompanyForm.controls['address'].value;
            this.companyEntered.postalCode = this.addCustomerCompanyForm.controls['postalCode'].value;
            this.companyEntered.city = this.addCustomerCompanyForm.controls['city'].value;
            this.companyEntered.country = this.addCustomerCompanyForm.controls['country'].value;
            this.companyEntered.siren = this.addCustomerCompanyForm.controls['siret'].value;
            this.companyEntered.tva = this.addCustomerCompanyForm.controls['tva'].value;
            this.similarCustomers = [];
            this.similarCompany = [];
            this.companySelected = null;
            this.customerCompanySelected = null;
            this.similarCompanyForm.controls['similarCompany'].reset();
            var pays = this.addCustomerCompanyForm.controls['country'].value;
            let country = this.countries.find(c => c.name.toLowerCase() == pays.toLowerCase() || c.vo.toLowerCase() == pays.toLowerCase()).name;
            var postalCode = this.addCustomerCompanyForm.value.postalCode;
            var city = this.addCustomerCompanyForm.value.city;
            this.getSimilarCompanySub = this.apiService.getSimilarCompany(country, postalCode, city).subscribe(data => {
                if (data.length > 0) {
                    this.showListCompany = true;
                    this.similarCompany = data;
                }
                else {
                    this.isNewCompany = true;
                    this.displayCustomerForm();
                    this.initLanguage();
                    this.newCustomer = true;
                }
                this.showMailForm = false;
                this.showCompanyForm = false;
                if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.getSimilarCompanySub != null) this.getSimilarCompanySub.unsubscribe();
            })
        }
        else {
            this.addCustomerCompanyForm.markAllAsTouched();
        }
    }

    returnToMailForm() {
        this.showCompanyForm = false;
        this.showMailForm = true;
    }

    /// Vue Liste des sociétés 
    chooseCompany(value: any) {
        if (this.companySelected != null && this.companySelected != value) {
            this.dataCompanyForm.reset();
            this.dataCompanySelected = null;
            this.customerCompanyForm.reset();
            this.customerCompanySelected = null;
            this.addCustomerForm.reset();
        }
        this.companySelected = value;
        this.errorMsgCompany = false;
    }

    selectCompany() {
        if (this.similarCompanyForm.status == 'VALID') {
            if (this.companySelected != null) {
                this.errorMsgCompany = false;
                this.showListCompany = false;
                if (this.companySelected == "new") {
                    this.isNewCompany = true;
                    this.showCustomerForm = true;

                    if (this.addCustomerCompanyForm.controls['country'].value && (this.addCustomerCompanyForm.controls['country'].value.toLowerCase() == "france" || this.addCustomerCompanyForm.controls['country'].value.toLowerCase() == "spain" || this.addCustomerCompanyForm.controls['country'].value.toLowerCase() == "united kingdom")) {
                        this.mprRenault = true;
                    } else {
                        this.mprRenault = false;
                    }
                    this.addCustomerForm.controls["businessCode"].setValue("");
                    this.addCustomerForm.controls["ctc"].setValue("");
                    this.addCustomerForm.controls["idCtc"].setValue("");

                    this.initLanguage();
                }
                else {
                    this.showVerifCompany = true;
                    this.isNewCompany = false;
                }
            }
        }
        else {
            this.similarCompanyForm.markAllAsTouched();
            this.errorMsgCompany = true;
        }
    }

    displayCompanyForm() {
        this.showCompanyForm = true;
        this.showListCompany = false;
        this.errorMsgCompany = false;
    }


    /// Vue Vérification données société 
    selectInfosCompany(value: any) {
        this.dataCompanySelected = value;
        this.errorMsgVerifCompany = false;
    }

    displayListCustomers() {
        if (this.dataCompanyForm.status == 'VALID') {
            if (this.dataCompanySelected != null) {
                this.showVerifCompany = false;
                this.errorMsgVerifCompany = false;
                if (this.companySelected == "new") {
                    this.isNewCompany = true;
                    this.showCustomerForm = true;
                    this.initLanguage();
                    this.showListCompany = false;
                }
                else {
                    this.isNewCompany = false;
                    this.getCustomersCompanySub = this.apiService.getListUsersById(this.companySelected.listIdcolorUser).subscribe(data => {
                        this.similarCustomers = data;
                        this.showCustomerCompany = true;
                        this.showListCompany = false;
                        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
                    }, error => {
                        console.log(error);
                        if (this.getCustomersCompanySub != null) this.getCustomersCompanySub.unsubscribe();
                    })
                }
            }
        }
        else {
            this.errorMsgVerifCompany = true;
        }
    }

    displayListCompany() {
        this.showVerifCompany = false;
        this.showListCompany = true;
        this.errorMsgVerifCompany = false;
    }

    /// Vue Liste des utilisateurs de la société sélectionnée 

    select(value: any) {
        this.customerCompanySelected = value;
        this.errorMsgCustomer = false;
    }

    displayCustomerForm() {
        if (this.addCustomerCompanyForm.controls['country'].value && (this.addCustomerCompanyForm.controls['country'].value.toLowerCase() == "france" || this.addCustomerCompanyForm.controls['country'].value.toLowerCase() == "spain" || this.addCustomerCompanyForm.controls['country'].value.toLowerCase() == "united kingdom")) {
            this.mprRenault = true;
        } else {
            this.mprRenault = false;
        }
        this.addCustomerForm.controls["businessCode"].setValue("");
        this.addCustomerForm.controls["ctc"].setValue("");
        this.addCustomerForm.controls["idCtc"].setValue("");

        if (this.similarCompany.length > 0) {
            if (this.customerCompanyForm.status == 'VALID') {
                this.errorMsgCustomer = false;
                this.showCustomerForm = true;
                this.showCustomerCompany = false;
                this.addCustomerForm.controls['paintBrand'].setValidators([]);
                this.addCustomerForm.controls['haveScale'].setValidators([]);
                if (this.customerCompanySelected != 'new' && this.customerCompanySelected != null) {
                    this.addCustomerForm.controls["name"].setValue(this.customerCompanySelected.name);
                    this.addCustomerForm.controls["firstName"].setValue(this.customerCompanySelected.firstname);
                    this.addCustomerForm.controls["phone"].setValue(this.customerCompanySelected.phone);
                    this.addCustomerForm.controls["mobile"].setValue(this.customerCompanySelected.mobilePhone);
                    this.addCustomerForm.controls["language"].setValue(this.customerCompanySelected.language);
                    //this.addCustomerForm.controls["businessCode"].setValue(this.customerCompanySelected.businessCode);
                    this.addCustomerForm.controls["customerNumber"].setValue(this.customerCompanySelected.mrpAccount);
                    this.addCustomerForm.controls["customerCode"].setValue(this.customerCompanySelected.customerCode);
                    this.addCustomerForm.controls["compteTresor"].setValue(this.customerCompanySelected.compteTresor);
                    this.newCustomer = false;
                }
                else if (this.customerCompanySelected == 'new') {
                    this.newCustomer = true;
                    this.initLanguage();
                }
            }
            else {
                this.customerCompanyForm.markAllAsTouched();
                this.errorMsgCustomer = true;
            }
        }
        else {
            if (this.addCustomerCompanyForm.status == 'VALID') {
                this.showCustomerForm = true;
            }
            else {
                this.addCustomerCompanyForm.markAllAsTouched();
            }
        }

        this.addCustomerForm.controls['paintBrand'].setValidators([]);
    }

    displayVerifCompany() {
        this.showCustomerCompany = false;
        this.showVerifCompany = true;
        this.errorMsgCustomer = false;
    }


    /// Vue Formulaire Utilisateur

    getPreviousCustomerForm() {
        this.showCustomerForm = false;
        this.addCustomerForm.reset();
        if (this.companySelected != null) {
            if (this.companySelected == 'new') {
                this.showListCompany = true;
            }
            else {
                this.showCustomerCompany = true;
            }
        }
        else {
            this.showCompanyForm = true;
        }
    }

    newCustomerHaveScale(bool: boolean) {
        let res: any;
        if (bool) {
            this.addCustomerForm.controls['paintBrand'].setValidators([Validators.required]);
            res = 1;
        }
        else {
            this.addCustomerForm.controls['paintBrand'].setValidators([]);
            res = 2;
        }

        this.haveScale = bool;
        this.addCustomerForm.setValue({
            name: this.addCustomerForm.value.name,
            firstName: this.addCustomerForm.value.firstName,
            phone: this.addCustomerForm.value.phone,
            mobile: this.addCustomerForm.value.mobile,
            language: this.addCustomerForm.value.language,
            businessCode: this.addCustomerForm.value.businessCode,

            ctc: this.addCustomerForm.value.ctc,
            idCtc: this.addCustomerForm.value.idCtc,

            customerNumber: this.addCustomerForm.value.customerNumber,
            customerCode: this.addCustomerForm.value.customerCode,
            compteTresor: this.addCustomerForm.value.compteTresor,
            haveScale: res,
            paintBrand: this.addCustomerForm.value.paintBrand
        });

        this.addCustomerForm.controls['paintBrand'].updateValueAndValidity();
    }

    ///////

    ////// Commun Nouvel utilisateur / Vérification infos 
    hideCustomerInfo() {
        this.currentCustomer = null;
    }

    selectCustomer(customer: IColorUserV1) {

        console.log(customer);

        let tmpCountry: any = this.countries.find(c => c.name.toLowerCase() == customer.country.toLowerCase() || c.vo.toLowerCase() == customer.country.toLowerCase());
        if (tmpCountry)
            tmpCountry = tmpCountry.name;
        else
            tmpCountry = customer.country;

        if (this.isUser || this.isRedirectAffectation) {
            this.userSelected = customer;
            this.userForm.setValue({
                gender: '',
                name: customer.name,
                firstname: customer.firstname,
                mail: customer.mail,
                phone: customer.phone,
                mobile: customer.mobilePhone,
                language: customer.language
            });
            this.companyForm.setValue({
                socialReason: customer.socialReason,
                address: customer.address,
                postalCode: customer.postalCode,
                city: customer.city,
                country: tmpCountry,
                siret: customer.siren != null && customer.siren != undefined && customer.siren != "" ? customer.siren : "",
                tva: customer.tva != null && customer.tva != undefined && customer.tva != "" ? customer.tva : ""
            });
            this.closeModal();
        }
        if (this.isPayor) {
            this.payorSelected = customer;
            this.payorForm.setValue({
                gender: '',
                name: customer.name,
                firstname: customer.firstname,
                mail: customer.mail,
                phone: customer.phone,
                mobile: customer.mobilePhone,
                language: customer.language
            });
            this.payorSocietyForm.setValue({
                socialReason: customer.socialReason,
                address: customer.address,
                postalCode: customer.postalCode,
                city: customer.city,
                country: tmpCountry,
                siret: customer.siren != null && customer.siren != undefined && customer.siren != "" ? customer.siren : "",
                tva: customer.tva != null && customer.tva != undefined && customer.tva != "" ? customer.tva : ""
            });
            if (this.userSelected.idcolorUser == this.payorSelected.idcolorUser) {
                this.sameAsUser = true;
                this.sameFacturationAsUser = true;
                this.checkedClient = false;
                this.checked = false;
                this.copyClientData();
                this.copyFacturationData();
                this.checkedClient = true;
                this.checked = true;
            }
            else {
                this.sameAsUser = false;
                this.sameFacturationAsUser = false;
                if (this.checked) this.checked = false;
                if (this.checkedClient) this.checkedClient = false;
            }
            this.closeModal();
        }
    }

    //SelectCustomerAndSendID(customer: IColorUserV1) {
    //  this.SelectCustomer(customer);
    //  this.saveAndSendIDSub = this.apiService.saveColorUserAndSendID(customer, this.newCustomer).subscribe(data => {
    //      if(this.isPreprod && !this.isAdminLacour) {
    //          this.infoPreprod = true;     
    //          document.getElementById("infoPreprodModal").style.display = "block";
    //      }
    //  }, error => {
    //    console.log(error);
    //    if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
    //  });
    //  this.closeModal();
    //}

    customerHaveScale(bool: boolean) {
        let res: any;
        if (bool) {
            this.addCustomerForm.controls['paintBrand'].setValidators([Validators.required]);
            res = 1;
        }
        else {
            this.addCustomerForm.controls['paintBrand'].setValidators([]);
            res = 2;
        }

        this.haveScale = bool;
        this.addCustomerEmailForm.setValue({
            email: this.addCustomerEmailForm.value.email
        });
        this.addCustomerCompanyForm.setValue({
            socialReason: this.addCustomerCompanyForm.value.socialReason,
            address: this.addCustomerCompanyForm.value.address,
            postalCode: this.addCustomerCompanyForm.value.postalCode,
            city: this.addCustomerCompanyForm.value.city,
            country: this.addCustomerCompanyForm.value.country,
            siret: this.addCustomerCompanyForm.value.siret,
            tva: this.addCustomerCompanyForm.value.tva
        });
        this.addCustomerForm.setValue({
            name: this.addCustomerForm.value.name,
            firstName: this.addCustomerForm.value.firstname,
            phone: this.addCustomerForm.value.phone,
            mobile: this.addCustomerForm.value.mobilePhone,
            language: this.addCustomerForm.value.language,
            businessCode: this.addCustomerForm.value.businessCode,

            ctc: this.addCustomerForm.value.ctc,
            idCtc: this.addCustomerForm.value.idCtc,

            customerNumber: this.addCustomerForm.value.mrpAccount,
            customerCode: this.addCustomerForm.value.customerCode,
            compteTresor: this.addCustomerForm.value.compteTresor,
            haveScale: res,
            paintBrand: this.addCustomerForm.value.paintBrand
        });

        this.addCustomerForm.controls['paintBrand'].updateValueAndValidity();
    }

    showOtherCustomer(type: string) {
        this.ctcSub = this.apiService.getLstCtcByCountryAndOrDR(this.otherCustomer.country, this.otherCustomer.businessCode).subscribe(data => {
            this.ctcsFiltered = data;
            if (this.ctcSub != null) this.ctcSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.ctcSub != null) this.ctcSub.unsubscribe();
        });

        this.otherCustomerForm.setValue({
            name: this.otherCustomer.name,
            firstName: this.otherCustomer.firstname,
            phone: this.otherCustomer.phone,
            mobile: this.otherCustomer.mobilePhone,
            socialReason: this.otherCustomer.socialReason,
            address: this.otherCustomer.address,
            postalCode: this.otherCustomer.postalCode,
            city: this.otherCustomer.city,
            country: this.otherCustomer.country,
            language: this.otherCustomer.language,
            businessCode: this.otherCustomer.businessCode,

            ctc: this.otherCustomer.ctcName,
            idCtc: this.otherCustomer.idCtc,

            customerNumber: this.otherCustomer.mrpAccount,
            customerCode: this.otherCustomer.customerCode,
            compteTresor: this.otherCustomer.compteTresor
        });
        if (this.otherCustomerForm.value.country && (this.otherCustomerForm.value.country.toLowerCase() == "france" || this.otherCustomerForm.value.country.toLowerCase() == "spain" || this.otherCustomerForm.value.country.toLowerCase() == "united kingdom")) {
            this.mprRenaultOther = true;
            this.otherCustomerForm.controls['businessCode'].setValidators([Validators.required]);
        }
        else {
            this.mprRenaultOther = false;
            this.otherCustomerForm.controls['businessCode'].setValidators([]);
        }
        this.otherCustomerForm.controls['businessCode'].updateValueAndValidity();
        this.addCustomerForm.controls['businessCode'].updateValueAndValidity();
        switch (type) {
            case ('new'):
                this.showOther = true;
                break;
            case ('edit'):
                this.showOtherEdit = true;
                this.showEditForm = false;
                break;
        }
    }

    hideOtherCustomer(type: string) {
        this.otherCustomerForm.reset();
        switch (type) {
            case ('new'):
                this.showOther = false;
                break;
            case ('edit'):
                this.showOtherEdit = false;
                break;
        }
    }

    saveOtherCustomer(type: string) {
        this.otherCustomer.mail = this.addCustomerEmailForm.value.email;
        this.otherCustomer.socialReason = this.otherCustomerForm.value.socialReason;
        this.otherCustomer.address = this.otherCustomerForm.value.address;
        this.otherCustomer.city = this.otherCustomerForm.value.city;
        this.otherCustomer.postalCode = this.otherCustomerForm.value.postalCode;
        this.otherCustomer.country = this.countries.find(c => c.name.toLowerCase() == this.otherCustomerForm.value.country.toLowerCase() || c.vo.toLowerCase() == this.otherCustomerForm.value.country.toLowerCase()).name;

        this.otherCustomer.name = this.otherCustomerForm.value.name;
        this.otherCustomer.firstname = this.otherCustomerForm.value.firstName;
        this.otherCustomer.phone = this.otherCustomerForm.value.phone;
        this.otherCustomer.mobilePhone = this.otherCustomerForm.value.mobile;
        this.otherCustomer.language = this.otherCustomerForm.value.language;

        this.otherCustomer.idCtc = this.otherCustomerForm.value.idCtc;
        this.otherCustomer.ctcName = this.otherCustomerForm.value.ctc;

        this.otherCustomer.businessCode = this.otherCustomerForm.value.businessCode;
        this.otherCustomer.customerCode = this.otherCustomerForm.value.customerCode;
        this.otherCustomer.mrpAccount = this.otherCustomerForm.value.customerNumber;
        this.otherCustomer.compteTresor = this.otherCustomerForm.value.compteTresor;
        if (this.otherCustomerForm.valid) {
            this.sendID(this.otherCustomer, type);
        }
    }

    initCurrentCustomer(type: string) {
        var email;
        var companyForm;
        var companyCountry;
        var customerForm;
        var ctcName;
        var idCtc;
        switch (type) {
            case ('new'):
                if (this.customerCompanySelected != null && this.customerCompanySelected != 'new') {
                    email = this.customerCompanySelected.mail;
                    this.currentCustomer.idcolorUser = this.customerCompanySelected.idcolorUser;
                }
                else {
                    email = this.addCustomerEmailForm.value.email;
                }
                if (this.isNewCompany == false && this.dataCompanySelected == this.companySelected) // données récupérées
                {
                    companyForm = this.companySelected;
                    companyCountry = this.companySelected.country;
                }
                else // données saisies
                {
                    companyForm = this.addCustomerCompanyForm.value;
                    companyCountry = this.addCustomerCompanyForm.controls['country'].value;
                }
                customerForm = this.addCustomerForm;
                break;
            case ('edit'):
                email = this.editCustomerForm.value.email;
                companyForm = this.editCustomerForm.value;
                companyCountry = this.editCustomerForm.controls['country'].value;
                customerForm = this.editCustomerForm;
                break;
        }

        this.currentCustomer.mail = email;
        this.currentCustomer.socialReason = companyForm.socialReason;
        this.currentCustomer.address = companyForm.address;
        this.currentCustomer.city = companyForm.city;
        this.currentCustomer.postalCode = companyForm.postalCode;
        this.currentCustomer.country = this.countries.find(c => c.name.toLowerCase() == companyCountry.toLowerCase() || c.vo.toLowerCase() == companyCountry.toLowerCase()).name;
        this.currentCustomer.siren = companyForm.siret;
        this.currentCustomer.tva = companyForm.tva;

        this.currentCustomer.name = customerForm.value.name;
        this.currentCustomer.firstname = customerForm.value.firstName;
        this.currentCustomer.mobilePhone = customerForm.value.mobile;
        this.currentCustomer.phone = customerForm.value.phone;
        this.currentCustomer.language = customerForm.value.language;

        this.currentCustomer.businessCode = customerForm.value.businessCode;
        this.currentCustomer.customerCode = customerForm.value.customerCode;
        this.currentCustomer.mrpAccount = customerForm.value.customerNumber;
        this.currentCustomer.compteTresor = customerForm.value.compteTresor;

        this.currentCustomer.ctcName = customerForm.value.ctc;
        this.currentCustomer.idCtc = customerForm.value.idCtc;

        var valueHaveScale = ((customerForm.value.haveScale == false || customerForm.value.haveScale == null) ? 2 : customerForm.value.haveScale);
        this.currentCustomer.haveScale = valueHaveScale;

        this.currentCustomer.paintBrand = customerForm.value.paintBrand;
    }

    saveCustomer(type: string) {
        this.initCurrentCustomer(type);
        var customerForm = (type == 'new') ? this.addCustomerForm : this.editCustomerForm;
        if (customerForm.valid) {

            this.currentCustomer.ctcName = customerForm.value.ctc;
            this.currentCustomer.idCtc = customerForm.value.idCtc;

            this.saveSub = this.apiService.saveColorUser(this.currentCustomer, this.newCustomer, type, -1, "UserClientForm", true).subscribe(data => {
                //this.msgConfirmation = true;
                this.isModifCustomer = false;
                this.editCustomerForm.reset();
                this.searchCustomerForm.setValue({
                    country: this.searchCustomerForm.value.country,
                    postalCode: this.currentCustomer.postalCode
                });
                this.resetAddCustomerPart();
                this.searchCustomer();

                if (this.isPreprod && !this.isAdminLacour) {
                    this.infoPreprod = true;
                    document.getElementById("infoPreprodModal").style.display = "block";
                }

            }, error => {
                console.log(error);
                if (this.saveSub != null) this.saveSub.unsubscribe();
            });
        } else {
            customerForm.markAllAsTouched();
        }
    }

    saveAndSendCustomer(type: string) {
        this.initCurrentCustomer(type);
        var customerForm = (type == 'new') ? this.addCustomerForm : this.editCustomerForm;
        if (customerForm.valid) {
            this.sendID(this.currentCustomer, type);
        }
        else {
            customerForm.markAllAsTouched();
        }
    }

    sendID(customer: IColorUserV1, type: string) {
        this.saveAndSendIDSub = this.apiService.saveColorUserAndSendID(customer, this.newCustomer, type, -1, "UserClientForm").subscribe(data => {
            if (data == true) {
                this.currentCustomer = null;
                this.isModifCustomer = false;
                this.resetAddCustomerPart();
                this.editCustomerForm.reset();
                this.searchCustomerForm.setValue({
                    country: this.searchCustomerForm.value.country,
                    postalCode: customer.postalCode
                });
                this.searchCustomer();

                if (this.isPreprod && !this.isAdminLacour) {
                    this.infoPreprod = true;
                    document.getElementById("infoPreprodModal").style.display = "block";
                }
            }
        }, error => {
            console.log(error);
            if (this.saveAndSendIDSub != null) this.saveAndSendIDSub.unsubscribe();
        });
    }

    sort(sort: Sort, status: string) {
        var data = this.customersLst;
        Constants.sortScale(sort, status, data)

        this.customersLst = data.slice();
        this.customersSource = new MatTableDataSource(this.customersLst);
    }


    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param name
     */
    closeModalPreprod(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "none";
        this.infoPreprod = false;
    }

    closeModal() {
        // Ferme la modal
        this.customersSource = new MatTableDataSource(null);
        let modal = document.getElementById("finalModal");
        modal.style.display = "none";
        this.newCustomer = false;
        this.isModifCustomer = false;
        this.searchCustomerForm.reset();
        this.editCustomerForm.reset();
        this.resetAddCustomerPart();
        this.emailExists = false;
        this.showOther = false;
        this.otherCustomer = null;
        this.otherCustomerForm.reset();
        this.msgConfirmation = false;
        if (this.isFinish)
            this.router.navigate(['/']);
        else {
            this.isSearchCustomer = false;
            this.isFinish = false;
            this.currentCustomer = null;
        }
        this.customersLst = [];
    }

    calculateClasses() {
        let temp = {
            'contentWithTable': this.customersLst.length > 0 && !this.currentCustomer,
            'contentWithoutTable': this.isModifCustomer || this.addCustomer || this.customersLst.length == 0
        }
        return temp;
    }

    calculateClassesRadioButton() {
        let temp = {
            'disabledRadioButton': this.sameAsUser == true
        }
        return temp;
    }

    loadCtcOfDrCustomer(type: string, call: string) {
        var customerForm;
        var country;
        switch (type) {
            case ('new'):
                switch (call) {
                    case ("region"):
                        this.addCustomerForm.controls["businessCode"].setValue("");
                        this.addCustomerForm.controls["ctc"].setValue("");
                        this.addCustomerForm.controls["idCtc"].setValue("");
                        break;
                    case ("dr"):
                        this.addCustomerForm.controls["ctc"].setValue("");
                        this.addCustomerForm.controls["idCtc"].setValue("");
                        break;
                }
                country = this.addCustomerCompanyForm.controls['country'].value;
                customerForm = this.addCustomerForm;
                if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom") && !customerForm.value.businessCode) {
                    this.addCustomerForm.get('idCtc').disable();
                } else {
                    this.addCustomerForm.get('idCtc').enable();
                }
                break;
            case ('edit'):
                switch (call) {
                    case ("region"):
                        this.editCustomerForm.controls["businessCode"].setValue("");
                        this.editCustomerForm.controls["ctc"].setValue("");
                        this.editCustomerForm.controls["idCtc"].setValue("");
                        break;
                    case ("dr"):
                        this.editCustomerForm.controls["ctc"].setValue("");
                        this.editCustomerForm.controls["idCtc"].setValue("");
                        break;
                }
                country = this.editCustomerForm.value.country;
                customerForm = this.editCustomerForm;
                if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom") && !customerForm.value.businessCode) {
                    this.editCustomerForm.get('idCtc').disable();
                } else {
                    this.editCustomerForm.get('idCtc').enable();
                }
                break;
            case ('other'):
                switch (call) {
                    case ("region"):
                        //this.otherCustomerForm.controls["businessCode"].setValue("");
                        //this.otherCustomerForm.controls["ctc"].setValue("");
                        //this.otherCustomerForm.controls["idCtc"].setValue("");
                        break;
                    case ("dr"):
                        //this.otherCustomerForm.controls["ctc"].setValue("");
                        //this.otherCustomerForm.controls["idCtc"].setValue("");
                        break;
                }
                country = this.otherCustomerForm.value.country;
                customerForm = this.otherCustomerForm;
                if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom") && !customerForm.value.businessCode) {
                    this.otherCustomerForm.get('idCtc').disable();
                } else {
                    this.otherCustomerForm.get('idCtc').enable();
                }
                break;
        }
        let pays = this.countries.find(c => c.name.toLowerCase() == country.toLowerCase() || c.vo.toLowerCase() == country.toLowerCase()).name;
        this.ctcSub = this.apiService.getLstCtcByCountryAndOrDR(pays, customerForm.value.businessCode).subscribe(data => {
            this.ctcsFiltered = data;
            if (this.ctcSub != null) this.ctcSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.ctcSub != null) this.ctcSub.unsubscribe();
        });
    }

    ctcSelected(type: string) {

        switch (type) {
            case ('new'):
                this.addCustomerForm.value.ctc = this.ctcsFiltered.find(c => c.idCtc == this.addCustomerForm.value.idCtc).firstname + " " + this.ctcsFiltered.find(c => c.idCtc == this.addCustomerForm.value.idCtc).name;
                break;
            case ('edit'):
                this.editCustomerForm.value.ctc = this.ctcsFiltered.find(c => c.idCtc == this.editCustomerForm.value.idCtc).firstname + " " + this.ctcsFiltered.find(c => c.idCtc == this.editCustomerForm.value.idCtc).name;
                break;
            case ('other'):
                this.otherCustomerForm.value.ctc = this.ctcsFiltered.find(c => c.idCtc == this.otherCustomerForm.value.idCtc).firstname + " " + this.ctcsFiltered.find(c => c.idCtc == this.otherCustomerForm.value.idCtc).name;
                break;

        }
    }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    if (a == null) return -1;
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
